import './style.css'
import {CityPin} from "./CityPin";
import {MapCard} from "./MapCard";
import {ClassesMap} from "./ClassesMap";

customElements.define("city-pin", CityPin);
customElements.define("map-card", MapCard);
customElements.define("classes-map", ClassesMap);

const appDiv = document.querySelector('#app')
appDiv.appendChild(new ClassesMap())